<template>
  <section class="shipping">
    <div class="shipping-container">
      <article class="shipping-card" role="region" aria-labelledby="shipping-title">
        <h2 id="shipping-title" class="shipping-title">{{translations.wysylka.tytul}}</h2>

        <div class="shipping-table">
          <div class="shipping-row">
            <div class="cell label">{{translations.wysylka.cennik }}</div>
            <div class="cell value">{{translations.wysylka.cennikWartosc }}</div>
          </div>

          <div class="shipping-row">
            <div class="cell label">{{translations.wysylka.krajeDostawy }}</div>
            <div class="cell value">{{translations.wysylka.krajeDostawyWartosc }}</div>
          </div>

          <div class="shipping-row">
            <div class="cell label">{{translations.wysylka.czasWysylki }}</div>
            <div class="cell value">{{translations.wysylka.czasWysylkiWartosc }}</div>
          </div>

          <div class="shipping-row">
            <div class="cell label">{{translations.wysylka.polska }}</div>
            <div class="cell value">{{translations.wysylka.polskaWartosc }}</div>
          </div>

          <div class="shipping-row">
            <div class="cell label">{{translations.wysylka.europa }}</div>
            <div class="cell value">{{translations.wysylka.europaWartosc }}</div>
          </div>
        </div>
      </article>
    </div>
  </section>
</template>

<script>
import { translations } from '@/locales/lang'

export default {
  name: 'AppKontakt',
  computed: {
    translations() {
      return translations.value
    },
  },
}
</script>
